import { atom } from "recoil";

export const DataCountryState = atom({
  key: "DataCountryState",
  default: [],
});
